import { TFunction } from 'i18next';
import FlatIcon from '../../public/static/images/categories/icons/icon-flat.svg';
import FlatNewIcon from '../../public/static/images/categories/icons/icon-flat-new.svg';
import FlatSecondaryIcon from '../../public/static/images/categories/icons/icon-flat-secondary.svg';
import VillaIcon from '../../public/static/images/categories/icons/icon-villa.svg';
import ObjectIcon from '../../public/static/images/categories/icons/icon-object.svg';
import SectorIcon from '../../public/static/images/categories/icons/icon-sector.svg';
import OfficeIcon from '../../public/static/images/categories/icons/icon-office.svg';
import GarageIcon from '../../public/static/images/categories/icons/icon-garage.svg';
import { Category } from '../../graphql/types';
import { capitalizeFirstLetter } from './common';

type CategoryData = {
  searchFormStat: string;
  formStat: string;
  icon: typeof FlatIcon;
  newAdFormStat?: string;
  name?: string;
};

type CategoryId = 1 | 2 | 3 | 5 | 7 | 8 | 9 | 10;

export const fillCategoriesWithData = (
  categories: Category[],
  withSorting = false,
  t?: TFunction<'translation', undefined>
) => {
  const customOrder = ['1', '2', '3', '5', '10', '9', '7', '8'];

  const categoriesDataMap: Record<CategoryId, CategoryData> = {
    1: {
      searchFormStat: 'new-search-flat-category',
      formStat: 'new-search-form-flat',
      newAdFormStat: 'create_ad_step2_category_apartment',
      icon: FlatIcon
    },
    2: {
      searchFormStat: 'new-search-flat-new-category',
      formStat: 'new-search-form-flat-new',
      icon: FlatNewIcon,
      name: t ? t('pages.current_item.categories.id_2') : ''
    },
    3: {
      searchFormStat: 'new-search-flat-secondary-category',
      formStat: 'new-search-form-flat-secondary',
      icon: FlatSecondaryIcon,
      name: t ? t('pages.current_item.categories.id_3') : ''
    },
    5: {
      searchFormStat: 'new-search-villa-category',
      formStat: 'new-search-form-villa',
      newAdFormStat: 'create_ad_step2_category_house',
      icon: VillaIcon
    },
    7: {
      searchFormStat: 'new-search-office-category',
      formStat: 'new-search-form-office',
      newAdFormStat: 'create_ad_step2_category_office',
      icon: OfficeIcon
    },
    8: {
      searchFormStat: 'new-search-garage-category',
      formStat: 'new-search-form-garage',
      newAdFormStat: 'create_ad_step2_category_garage',
      icon: GarageIcon
    },
    9: {
      searchFormStat: 'new-search-land-category',
      formStat: 'new-search-form-land',
      newAdFormStat: 'create_ad_step2_category_land',
      icon: SectorIcon
    },
    10: {
      searchFormStat: 'new-search-object-category',
      formStat: 'new-search-form-object',
      newAdFormStat: 'create_ad_step2_category_object',
      icon: ObjectIcon
    }
  };

  const filledCategories = (categories || []).map(category => {
    const { id, name } = category;

    const newData = categoriesDataMap[Number(id) as CategoryId];

    return {
      id,
      ...newData,
      name: newData?.name ? capitalizeFirstLetter(newData.name) : name
    };
  });

  return withSorting
    ? filledCategories.sort(
        (firstCategory, secondCategory) =>
          customOrder.indexOf(firstCategory.id) -
          customOrder.indexOf(secondCategory.id)
      )
    : filledCategories;
};
